import axios from "axios";
import { API_URL } from "../Globals";
import Cookies from 'universal-cookie';

const axiosInstance = axios.create({
  // baseURL: "http://localhost:4000/",
  baseURL: API_URL,
  withCredentials: true,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // 401 means the session is invalid/expired; clear auth and redirect to login.
    // 403 is often feature-level authorization (valid session but no permission),
    // so pages should handle it instead of forcing a global logout.
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("login_role");
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("partner");

      const cookie = new Cookies();
      cookie.remove('userData', { path: '/' });
      cookie.remove('authSession', { path: '/' });

      if (window.location.pathname !== '/login') {
         window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
